import { render, staticRenderFns } from "./TableNicknames.vue?vue&type=template&id=7d71abfc&scoped=true"
import script from "./TableNicknames.js?vue&type=script&lang=js&external"
export * from "./TableNicknames.js?vue&type=script&lang=js&external"
import style0 from "./TableNicknames.vue?vue&type=style&index=0&id=7d71abfc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d71abfc",
  null
  
)

export default component.exports